"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _EditSystemComponent = _interopRequireDefault(require("../components/EditSystemComponent"));
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _helper = require("../common_features/utility/helper");
var _systemsReducer = require("../common_features/redux/reducers/systemsReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EditSystem = () => {
  var _location$state, _Date;
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const location = (0, _reactRouterDom.useLocation)();
  const data = location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.date;
  const {
    selectedSystems,
    selectedDate
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const [value, setValue] = (0, _react.useState)(selectedDate);
  const [initialDate, setInitialDate] = (0, _react.useState)(data ? (_Date = new Date(data)) === null || _Date === void 0 ? void 0 : _Date.toISOString() : "");
  const dateChange = date => {
    setValue(date);
  };
  const handleCancel = () => {
    navigate(-1);
  };
  const handleSave = () => {
    dispatch((0, _systemsReducer.setSelectedDate)(new Date(value)));
    const formatedDate = "".concat(value === null || value === void 0 ? void 0 : value.getFullYear(), "-").concat(((value === null || value === void 0 ? void 0 : value.getMonth()) + 1).toString().length === 1 ? "0".concat((value === null || value === void 0 ? void 0 : value.getMonth()) + 1) : (value === null || value === void 0 ? void 0 : value.getMonth()) + 1, "-").concat((value === null || value === void 0 ? void 0 : value.getDate().toString().length) === 1 ? "0".concat(value === null || value === void 0 ? void 0 : value.getDate()) : value === null || value === void 0 ? void 0 : value.getDate());
    navigate(_RoutePath.default.addNotes.useLink, {
      state: {
        changesFlag: new Date(value).toISOString() != initialDate,
        serviceLogType: _helper.SERVICE_LOGS_TYPE.SYSTEM_UPDATED,
        payload: {
          installedDate: formatedDate
        }
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_EditSystemComponent.default, {
    backNavigationScreen: "System Dashboard",
    headerText: "Edit System",
    saveBtnTitle: "Continue",
    rightNavHeading: "Cancel",
    inputLabel: "Installation Date",
    modelNumber: (selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemPartNumber) + " " + (selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemModelNumber),
    maxInstallationDate: new Date(),
    handleCancel: handleCancel,
    handleBack: handleCancel,
    saveBtnClick: handleSave,
    dateChange: dateChange,
    value: new Date((0, _helper.getDate)(value)),
    saveBtnDisabled: !value ? true : false
  });
};
var _default = exports.default = EditSystem;